import * as React from 'react';
import {
  Button, Dialog
} from 'src/components';
import {
  DialogContentText
} from '@mui/material';
import DialogTitle from 'src/components/DialogTitle';
import DialogContent from 'src/components/DialogContent';
import DialogActions from 'src/components/DialogActions';

import { translate } from 'src/i18n/tHelper';

const translatePath = "common";

export interface ConfirmationOptions {
  catchOnCancel?: boolean;
  variant?: 'danger' | 'info' | 'error';
  title?: string;
  description: string | React.ReactNode;
}

interface ConfirmationDialogProps extends ConfirmationOptions {
  open: boolean;
  onSubmit: () => void;
  onClose: () => void;
  onClosed: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  variant,
  description,
  onSubmit,
  onClose,
  onClosed
}) => {
  return (
    <Dialog
      fullWidth
      open={open}
      maxWidth="sm"
      scroll="paper"
      keepMounted
      sx={{
        zIndex: 32767
      }}
      TransitionProps={{ onExited: onClosed }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {variant === 'danger' ? (
          <>
            <Button color="error" customType='check' onClick={onSubmit}>
              {translate(translatePath, "Evet")}
            </Button>
            <Button customType='cancel' onClick={onClose} autoFocus>
              {translate(translatePath, "Vazgeç")}
            </Button>
          </>
        ) : variant === 'error' ? (
          <Button customType='check' onClick={onClose}>
            {translate(translatePath, "Tamam")}
          </Button>
        ) : <Button customType='check' onClick={onSubmit}>
          {translate(translatePath, "Tamam")}
        </Button>}
      </DialogActions>
    </Dialog>
  );
};
